<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="2">商品范围</el-col>
            <el-col :span="4">
                <el-switch
                        v-model="selectAll"
                        active-text="所有商品"
                        inactive-text="自定义商品" @change="productChange">
                </el-switch>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <div class="collage-prod">
                <div class="btns">
                    <el-col :span="8">
                        <el-input v-model="collageName" placeholder="拼单名称" :disabled="true"></el-input>
                    </el-col>
                    <el-col :span="2" :offset="12">
                        <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" class="header-btn" @click="add()">新建商品</el-button>
                    </el-col>
                </div>
                <el-table :data="selectList" v-loading="listLoading" v-show="!selectAll" border fit
                          highlight-current-row stripe
                          style="width: 100%;">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column align="center" v-show="false" v-if="listLoading" label="商品配置id">
                        <template slot-scope="scope">
                            <span>{{scope.row.id}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="商品名称">
                        <template slot-scope="scope">
                            <span>{{scope.row.productName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="商品类型">
                        <template slot-scope="scope">
                            <span>{{scope.row.productType == 1 ? '促销套装' : '单品'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                            <el-button type="danger" size="mini" @click="deleteProduct(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog title="所有商品" :visible.sync="designTable" width="50%" center class="main-title">
                    <el-row>
                        <el-input v-model="activeNo" v-show="false" placeholder="拼单活动号"></el-input>
                    </el-row>
                    <el-row>
                        <el-checkbox-group v-model="checkedBaseData" @change="checkBaseDataItem">
                            <el-checkbox v-for="item in baseDataList" :label="item" :key="item.productId"
                                         class="check-item">
                                {{item.productName}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-row>
                    <span slot="footer" class="dialog-footer">
            <el-button @click="designTable=false">取 消</el-button>
            <el-button type="primary" @click="sureAct">确 定</el-button>
        </span>
                </el-dialog>
            </div>
        </el-row>
    </div>
</template>

<script>
    import md5 from 'js-md5';
    import {
        getCollageProductConfigList,
        saveCollageProductConfigList,
        deleteCollageProductConfig,
        setCollageConfigProduct
    } from  '@/api/api'

    export default ({
        data() {
            return {
                list: [],
                selectAll: true,
                activeNo: '',//拼单活动
                collageId: '',//拼单id
                collageName: '',//拼单名称
                checkedBaseData: [],    // 已选中的
                saveDataList: [],
                isShow:false,
                selectList:[],//已选择的
                baseDataList: [],   // 全部商品集合
                designTable: false,  // 是否显示商品弹窗
                listLoading: false,  // 查询table的loading
            }
        },
        created() {
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.activeNo = this.$route.query.activeNo;
            this.collageName = this.$route.query.name;
            this.selectAll = this.$route.query.productType == 1;
            this.collageId = this.$route.query.collageId;
            this.designTable = false;
            this.getAllProdList();
        },
        methods: {
            // 选中/不选中基础数据子项事件
            checkBaseDataItem() {
            },
            add(){
                this.designTable = true;
                this.selectAll=false;
            },
            // 获取所有商品列表和 获取已选中的商品列表
            getAllProdList() {
                this.listLoading = true;
                getCollageProductConfigList({activeNo: this.activeNo}).then((res) => {
                    this.listLoading = false;
                    if (res.data.status == 200) {
                        this.baseDataList = res.data.value.allList;
                        this.selectList = res.data.value.selectList;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            productChange(){
                //全品类
                setCollageConfigProduct({
                    collageId: this.collageId,
                    activeNo: this.activeNo,
                    productType: (this.selectAll ? 1 : 2)
                }).then(res => {
                    this.listLoading = false;
                    if (res.data.status == 200) {
                        this.designTable = false;
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        if (this.selectAll) {
                            this.checkedBaseData = [];
                        } else {
                            if (this.checkedBaseData.length == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '未配置拼单商品',
                                    type: 'error'
                                });
                            }
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            // 点击确定 保存已选商品
            sureAct() {
                if (this.checkedBaseData.length == 0) {
                    this.$message({
                        showClose: true,
                        message: '请选择商品',
                        type: 'error'
                    });
                } else {
                    for (var j = 0, len = this.checkedBaseData.length; j < len; j++) {
                        this.checkedBaseData[j].activeNo = this.activeNo;
                    }
                    for (var j = 0; j <  this.checkedBaseData.length; j++) {
                        for (var i = 0; i < this.selectList.length; i++) {
                            if(this.checkedBaseData[j]){
                                if(this.checkedBaseData[j].productName===this.selectList[i].productName){
                                    this.$message({
                                        showClose: true,
                                        message: this.selectList[i].productName+'商品已存在',
                                        type: 'error'
                                    });
                                    return;
                                }
                            }
                        }
                    }

                    saveCollageProductConfigList({list:encodeURIComponent(JSON.stringify(this.checkedBaseData))}).then(res => {
                        if (res.data.status == 200) {
                            this.designTable = false;
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.checkedBaseData=[];
                            this.getAllProdList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            deleteProduct(row){
                this.$confirm('删除商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //删除商品
                    this.listLoading = true;
                    deleteCollageProductConfig({id: row.id}).then(res => {
                        this.listLoading = false;
                        if (res.data.status == 200) {
                            this.designTable = false;
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getAllProdList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            }
        }
    })
</script>

<style lang="scss">
    .collage-prod {
        .btns {
            margin: 10px;
        }
        .el-checkbox-group {
            max-height: 300px;
            overflow: scroll;
            label {
                min-width: 190px;
                margin-bottom: 20px;
                margin-left: 0;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/collage/productList.vue